import { useCallback, useEffect, useState } from 'react';

export interface CanonicalProjectStats {
  activeShares: string;
  activeSharesDisplayWhole: number;
  activeShareholders: number;
  activeRows: number;
  valueUsd: string;
  validStatuses: string[];
}

export interface CanonicalPublicStats {
  aureus: CanonicalProjectStats;
  finux: CanonicalProjectStats;
  combined: {
    activeShares: string;
    activeSharesDisplayWhole: number;
    activeShareholders: number;
    shareholderDedupeStatus: 'deduplicated' | 'not_deduplicated' | 'unknown';
    valueUsd: string;
  };
  source: { aureusProject: string; finuxProject: string; table: string; column: string; generatedAt: string };
}

export function useCanonicalPublicStats() {
  const [stats, setStats] = useState<CanonicalPublicStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const refresh = useCallback(async () => {
    try {
      setError(null);
      const response = await fetch('/api/public/canonical-share-stats', { cache: 'no-store' });
      const payload = await response.json();
      if (!response.ok || !payload?.data) throw new Error(payload?.error || `HTTP ${response.status}`);
      setStats(payload.data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to load canonical public stats');
    } finally { setLoading(false); }
  }, []);
  useEffect(() => {
    refresh();
    const interval = window.setInterval(refresh, 60_000);
    return () => window.clearInterval(interval);
  }, [refresh]);
  return { stats, loading, error, refresh };
}
